export default {
  metadata: {
    version: '1.0.0',
    id: 'avatar_progress_ring-1.0.0',
    name: 'JDSAvatarV2ProgressRing'
  },
  hierarchy: {
    container: ['base-arc', 'ring-arc', 'jds_avatar_v2_default']
  },
  base: {
    container: {
      'flex-direction': '{flexDirection.stack}',
      'justify-content': '{justifyContent.center}',
      'align-items': '{alignItems.center}',
      opacity: '{opacity.enabled}',
      hidden: false
    },
    'base-arc': {
      radius: 24,
      arcWidth: 2,
      fill: '{primaryGrey40}',
      start: 0,
      end: 360,
      'z-index': 1,
      disabled: true
    },
    'ring-arc': {
      radius: 24,
      arcWidth: 2,
      fill: '{primary50}',
      start: 0,
      end: 270,
      'z-index': 2,
      disabled: true
    },
    jds_avatar_v2_default: {
      size: 'medium'
    }
  },
  variant: {
    size: {
      'xtra-xtra-large': {
        jds_avatar_v2_default: {
          size: 'xtra-xtra-large'
        },
        'base-arc': {
          radius: 68,
          arcWidth: 4
        },
        'ring-arc': {
          radius: 68,
          arcWidth: 4
        }
      },
      'xtra-large': {
        jds_avatar_v2_default: {
          size: 'xtra-large'
        },
        'base-arc': {
          radius: 34,
          arcWidth: 3
        },
        'ring-arc': {
          radius: 34,
          arcWidth: 3
        }
      },
      large: {
        jds_avatar_v2_default: {
          size: 'large'
        },
        'base-arc': {
          radius: 30,
          arcWidth: 3
        },
        'ring-arc': {
          radius: 30,
          arcWidth: 3
        }
      },
      small: {
        jds_avatar_v2_default: {
          size: 'small'
        },
        'base-arc': {
          radius: 20,
          arcWidth: 2
        },
        'ring-arc': {
          radius: 20,
          arcWidth: 2
        }
      },
      'xtra-small': {
        jds_avatar_v2_default: {
          size: 'xtra-small'
        },
        'base-arc': {
          radius: 16,
          arcWidth: 2
        },
        'ring-arc': {
          radius: 16,
          arcWidth: 2
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{opacity.disabled}'
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      size: {
        values: [
          'medium',
          'xtra-xtra-large',
          'xtra-large',
          'large',
          'small',
          'xtra-small'
        ]
      },
      disabled: {
        values: [false, true]
      }
    },
    data: {
      jds_avatar_v2_default: {
        image: {
          type: 'image',
          name: 'avatarImage'
        },
        initials: {
          type: 'string',
          name: 'avatarInitials'
        },
        kind: {
          type: 'JDSAvatarV2Default.kind',
          name: 'avatarKind'
        }
      },
      'ring-arc': {
        end: {
          type: 'number',
          name: 'progress',
          function: true
        }
      }
    },
    a11y: {
      container: {
        properties: {
          'aria-label': {
            name: 'ariaLabel',
            value: 'Avatar with Progress Activity Ring'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
